import { CAT_ACTIVITY_LEVEL } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";

import { createEnumTranslations } from "./createEnumTranslations";

const lifestyles = Object.keys(CAT_ACTIVITY_LEVEL) as (keyof typeof CAT_ACTIVITY_LEVEL)[];

export const useCatLifestyle = () => {
  const tLifestyles = useTranslations("Cats.LifeStyles");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: lifestyles,
    translate: (lifestyle) => {
      if (lifestyle === "UNKNOWN") {
        return unknown;
      }

      return tLifestyles(snakeCaseToCamelCase(lifestyle));
    },
    fallback: unknown,
  });
};
